/* eslint-disable @typescript-eslint/no-explicit-any */

import { api, ApiResponse } from '@/api/api';
import { ACCOUNT_URLS } from '@/api/url';
import { AccountRole } from '@/types/enums';
import { isAxiosError } from 'axios';

export const apiGetAccountProfile = async (): Promise<ApiResponse<Account>> => {
  try {
    const response = await api.get<ApiResponse<Account>>(ACCOUNT_URLS.GET);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface UpdateAccountProfilePayload {
  name: string;
}

export const apiUpdateAccountProfile = async ({
  payload
}: {
  payload: UpdateAccountProfilePayload;
}): Promise<ApiResponse<void>> => {
  try {
    const response = await api.put<ApiResponse<void>>(ACCOUNT_URLS.UPDATE_PROFILE, payload);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface GetInvitationResponse {
  email: string;
  role: AccountRole;
  agency_name: string;
}

export const apiGetInvitation = async (
  token: string
): Promise<ApiResponse<GetInvitationResponse>> => {
  try {
    const response = await api.get<ApiResponse<GetInvitationResponse>>(
      ACCOUNT_URLS.GET_INVITATION,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export const apiUpgradeRequest = async (): Promise<ApiResponse<void>> => {
  try {
    const response = await api.post<ApiResponse<void>>(ACCOUNT_URLS.UPGRADE_REQUEST);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};
